import React from "react";
import PropTypes from "prop-types";

import Select from "react-select";

import { REQUEST_NATURES } from "../project/constants";

const RequestNatureSelect = ({
  value,
  isMulti,
  onChange,
  placeholder,
  label,
  name,
  disabled
}) => {
  const options = REQUEST_NATURES.map((item) => ({
    label: item,
    value: item
  })).sort((a, b) => {
    if (a.label > b.label) return 1;
    if (b.label > a.label) return -1;
    return 0;
  });

  return (
    <React.Fragment>
      {label ? (
        <label
          className={`control-label ${!label ? "hidden" : ""}`}
          htmlFor="request-nature-select"
          style={{ textTransform: "uppercase" }}
        >
          {label}
        </label>
      ) : null}
      <Select
        id="request-nature-select"
        name={name}
        className="react-select-container"
        classNamePrefix="react-select-container"
        fullwidth
        placeholder={placeholder}
        value={value}
        options={options}
        isClearable
        onChange={(v) => onChange(name, v)}
        isMulti={isMulti}
        menuPortalTarget={document.body}
        isDisabled={disabled}
      />
    </React.Fragment>
  );
};

RequestNatureSelect.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isMulti: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool
};

RequestNatureSelect.defaultProps = {
  placeholder: "Select",
  label: "Request Nature",
  isMulti: true
};

export default RequestNatureSelect;
